






























import { mapGetters } from 'vuex';

import { InsightsLandingCard, UiIconButton } from '../../components';

import { DeviceEnum, FeatureIdEnum } from '../../enums';

import { GUARDS_EXECUTOR, InsightsLandingGuard } from '../../guards';

import { FeatureNode } from '../../models';

import { APP_CONSTS } from '../../store/app/app.consts';
import { CONTEXT_CONSTS } from '../../store/context/context.consts';

import { FeaturesTreeUtils } from '../../utils';

enum NavigationActionsEnum {
  PREVIOUS,
  NEXT
}

export default {
  name: 'insights-landing',
  components: {
    UiIconButton,
    InsightsLandingCard
  },
  computed: {
    ...mapGetters(CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context
    }),
    ...mapGetters(APP_CONSTS.moduleName, {
      featuresTree: APP_CONSTS.getters.featuresTree
    }),
    insightsLandingClasses: function (): (string | Record<string, boolean>)[] {
      return [
        `${ this.baseClass }`,
        { [`${ this.baseClass }--blur-left`]: (this.leftButtonVisible) },
        { [`${ this.baseClass }--blur-right`]: (this.rightButtonVisible) }
      ];
    },
    cardsWrapperStyle: function (): Record<string, string> {
      let translateX: string;
      if (!!this.hoveredCardId) {
        const indexOfHoveredCard = this.visibleCards.findIndex((card: Record<string, any>) => (card.name === this.hoveredCardId));
        if (indexOfHoveredCard > 0) {
          const cardWidthGrowth = `(${ this.hoveredCardWidth } - ${ this.cardWidth })`;
          if (indexOfHoveredCard < (this.visibleCards.length - 1)) {
            translateX = `calc(${ cardWidthGrowth } / 2 * -1)`;
          } else {
            translateX = `calc(${ cardWidthGrowth } * -1)`;
          }
        }
      }
      return {
        margin: `-${ this.cardMargin }`,
        ...(!!translateX && { transform: `translate3d(${ translateX }, 0, 0)` })
      };
    },
    visibleCards: function (): Record<string, any>[] {
      return this.cards.slice(this.navigationIndex, this.navigationIndex + this.cardsPerPage);
    },
    cards: function (): Record<string, any>[] {
      const featureNode = FeaturesTreeUtils.getFeatureNode(FeatureIdEnum.INSIGHTS, this.featuresTree[this.context.domain]);
      return featureNode.children.map((childFeatureNode: FeatureNode) => {
        return {
          name: this.$epb.messages.app.features[childFeatureNode.id],
          description: this.messages.card.descriptions[childFeatureNode.id],
          route: {
            ...this.$route,
            name: childFeatureNode.routeName
          },
          imageUrl: require(`../../assets/media/image/insights/${ childFeatureNode.id }.jpg`),
          messages: this.messages.card
        };
      });
    },
    cardsPerPage: function (): number {
      if (this.$epb.device <= DeviceEnum.MOBILE) {
        return 1;
      }
      if (this.$epb.device <= DeviceEnum.TABLET) {
        return 2;
      }
      return 3;
    },
    leftButtonVisible: function (): boolean {
      return this.navigationIndex > 0;
    },
    rightButtonVisible: function (): boolean {
      return (this.navigationIndex + this.cardsPerPage < this.cards.length);
    },
    cardWidth: function (): string {
      return `calc(${ (100 / this.visibleCards.length) }% - (${ this.cardMargin } * 2))`;
    },
    messages: function () {
      return this.$epb.messages.insights.landing;
    }
  },
  data: function () {
    return {
      baseClass: 'epb-insights-landing',
      cardMargin: '12px',
      hoveredCardWidth: '60%',
      hoveredCardId: undefined,
      navigationIndex: 0,
      NavigationActionsEnum
    };
  },
  methods: {
    navigate: function (action: NavigationActionsEnum): void {
      const navigation = {
        [NavigationActionsEnum.PREVIOUS]: () => this.navigationIndex--,
        [NavigationActionsEnum.NEXT]: () => this.navigationIndex++
      }[action]();
    },
    getCardStyle: function (card: Record<string, any>): Record<string, string> {
      return {
        width: ((card.name === this.hoveredCardId) ? this.hoveredCardWidth : this.cardWidth),
        margin: this.cardMargin
      };
    }
  },
  beforeRouteEnter: GUARDS_EXECUTOR([
    InsightsLandingGuard.execute
  ]),
  beforeRouteUpdate: GUARDS_EXECUTOR([
    InsightsLandingGuard.execute
  ])
};
